import { Component, Mixins } from "vue-property-decorator";
import CompaniesMixin from "@/mixins/http/SpecialInitiatives/CompaniesMixin";
import store from "@/store";

@Component
class SpecialInitiativesCompaniesService extends Mixins(CompaniesMixin) {
  created() {
    this.$store = store;
  }

  getSalesAgencies() {
    return this.index("ad_sales_agency");
  }
  getBroadcasters() {
    return this.index("broadcaster");
  }
}

export default new SpecialInitiativesCompaniesService();
